/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-restricted-syntax */
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

// 获取用户个人背包页面详情信息 http://wiki.xunlei.cn/pages/viewpage.action?pageId=90608991
export const ny_my_cards = createAsyncThunk(
  '/live/activity/ny_my_cards',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<Omit<InitialStateType, 'rank_wealth' | 'rank_charm'>>
    >('/live/activity/ny_my_cards', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)
// 排行榜
export const ny_rank_list = createAsyncThunk(
  '/live/activity/ny_rank_list',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<Pick<InitialStateType, 'rank_wealth' | 'rank_charm'>>
    >('/live/activity/ny_rank_list', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)
// 抽卡
export const ny_get_card = createAsyncThunk(
  '/live/activity/ny_get_card',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<{
        card_no: number
        card_list: InitialStateType['card_list']
        gen_box_can: InitialStateType['gen_box_can']
        left_times: InitialStateType['left_times']
      }>
    >('/live/activity/ny_get_card', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)
// 开宝箱
export const ny_gen_box = createAsyncThunk(
  '/live/activity/ny_gen_box',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<{
        box_level: number
        box_list: InitialStateType['box_list']
        card_list: InitialStateType['card_list']
      }>
    >('/live/activity/ny_gen_box', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)

// 完成任务

export const ny_get_times = createAsyncThunk(
  '/live/activity/ny_get_times',
  async (job_id: number, store: any) => {
    const resp = await http.post<
      HiyaRes<{
        left_times: InitialStateType['left_times']
        job_list: InitialStateType['job_list']
        add_times: number
      }>
    >(
      '/live/activity/ny_get_times',
      {
        job_id,
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
interface InitialStateType {
  left_times?: number
  card_list?: Array<number>
  job_list?: Array<number>
  box_list?: Array<number>
  gen_box_can?: 1 | 2
  people_gen_box?: number
  rank_wealth?: Array<any>
  rank_charm?: Array<any>
}

const initialState: InitialStateType = {}

export const CorbanSlice = createSlice({
  name: 'Corban',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(ny_my_cards.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    builder.addCase(ny_rank_list.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    builder.addCase(ny_get_card.fulfilled, (state, action) => {
      const {card_no, ...other} = action.payload
      Object.assign(state, other)
    })
    builder.addCase(ny_gen_box.fulfilled, (state, action) => {
      const {box_level, ...other} = action.payload
      Object.assign(state, other)
    })
    builder.addCase(ny_get_times.fulfilled, (state, action) => {
      const {add_times, ...other} = action.payload
      Object.assign(state, other)
    })
  },
})
export default CorbanSlice.reducer
export const CorbanActions = CorbanSlice.actions

export const useCorbanState = () => {
  const data = useSelector((state) => state.Corban)
  return data
}
